import Splide from '@splidejs/splide';

export function Carousels(selector, config = {}, sizerClass = null) {
    if (!selector) {
        return;
    }


    document.addEventListener('DOMContentLoaded', function () {
        const carousels = document.querySelectorAll(selector);

        if (carousels.length > 0) {

            const defaultConfig = {
                perPage: 3,
                pagination: false,
                arrows: false,
                autoplay: false,
                mediaQuery: 'min',
            };


            const mergedConfig = {...defaultConfig, ...config};


            if (sizerClass) {
                const padding = sizer(sizerClass);
                mergedConfig.breakpoints[1024].padding = {
                    left: `${padding}px`,
                    right: '5%'
                };
            }


            carousels.forEach(
                carousel => {
                    const instance = new Splide(carousel, mergedConfig).mount();
                });

        }

    });

    function sizer(sizerClass) {
        const container = document.querySelector(sizerClass);
        const containerStyle = getComputedStyle(container);

        // Get container's max-width
        const containerMaxWidth = parseFloat(containerStyle.maxWidth);

        // Get container's left padding
        const containerPaddingLeft = parseFloat(containerStyle.paddingLeft);

        const viewportWidth = window.innerWidth;

        // Calculate the margin without the padding
        let containerMargin = (viewportWidth - containerMaxWidth) / 2;

        // Add the left padding to the calculated margin
        containerMargin += containerPaddingLeft;

        return containerMargin > 0 ? containerMargin : 0;
    }


}